{
  "ember": {
    "ember-50": "#22272b",
    "ember-100": "#1c2a3b",
    "ember-150": "#1c2a4c",
    "ember-200": "#25265c",
    "ember-250": "#331f68",
    "ember-300": "#441170",
    "ember-350": "#611175",
    "ember-400": "#800f73",
    "ember-450": "#9f096a",
    "ember-500": "#bc0758",
    "ember-550": "#d7153a",
    "ember-600": "#de2b34",
    "ember-650": "#e43b2e",
    "ember-700": "#e94927",
    "ember-750": "#ee5621",
    "ember-800": "#f3631b",
    "ember-850": "#f77300",
    "ember-900": "#f98200",
    "ember-950": "#fb9100",
    "ember-1000": "#fba000",
    "ember-1050": "#faaf05"
  },
  "earthfire": {
    "earthfire-50": "#523719",
    "earthfire-100": "#5f360d",
    "earthfire-150": "#6c3300",
    "earthfire-200": "#7a2e00",
    "earthfire-250": "#872600",
    "earthfire-300": "#941b00",
    "earthfire-350": "#a72a05",
    "earthfire-400": "#b9380b",
    "earthfire-450": "#cc4611",
    "earthfire-500": "#e05516",
    "earthfire-550": "#f3631b",
    "earthfire-600": "#f77300",
    "earthfire-650": "#f98200",
    "earthfire-700": "#fb9100",
    "earthfire-750": "#fba000",
    "earthfire-800": "#faaf05",
    "earthfire-850": "#fabb3b",
    "earthfire-900": "#fac757",
    "earthfire-950": "#fbd26f",
    "earthfire-1000": "#fcdd85",
    "earthfire-1050": "#fde79a"
  },
  "fuchsia-heat": {
    "fuchsia-heat-50": "#65004d",
    "fuchsia-heat-100": "#7b025f",
    "fuchsia-heat-150": "#920472",
    "fuchsia-heat-200": "#a90885",
    "fuchsia-heat-250": "#c10d99",
    "fuchsia-heat-300": "#d912ae",
    "fuchsia-heat-350": "#e61e92",
    "fuchsia-heat-400": "#f02d77",
    "fuchsia-heat-450": "#f53e5b",
    "fuchsia-heat-500": "#f6503e",
    "fuchsia-heat-550": "#f3631b",
    "fuchsia-heat-600": "#f77300",
    "fuchsia-heat-650": "#f98200",
    "fuchsia-heat-700": "#fb9100",
    "fuchsia-heat-750": "#fba000",
    "fuchsia-heat-800": "#faaf05",
    "fuchsia-heat-850": "#fabb3b",
    "fuchsia-heat-900": "#fac757",
    "fuchsia-heat-950": "#fbd26f",
    "fuchsia-heat-1000": "#fcdd85",
    "fuchsia-heat-1050": "#fde79a"
  },
  "polar-glow": {
    "polar-glow-50": "#002664",
    "polar-glow-100": "#013380",
    "polar-glow-150": "#03419e",
    "polar-glow-200": "#074fbd",
    "polar-glow-250": "#0d5ddc",
    "polar-glow-300": "#146cfd",
    "polar-glow-350": "#0077e7",
    "polar-glow-400": "#007ed0",
    "polar-glow-450": "#0082b8",
    "polar-glow-500": "#0082a2",
    "polar-glow-550": "#2e808e",
    "polar-glow-600": "#42929f",
    "polar-glow-650": "#54a3b0",
    "polar-glow-700": "#67b6c1",
    "polar-glow-750": "#79c8d3",
    "polar-glow-800": "#8cdbe5",
    "polar-glow-850": "#9adfe5",
    "polar-glow-900": "#a9e3e5",
    "polar-glow-950": "#b6e7e6",
    "polar-glow-1000": "#c4ebe7",
    "polar-glow-1050": "#d1eeea"
  },
  "glacier-pool": {
    "glacier-pool-50": "#441170",
    "glacier-pool-100": "#511e88",
    "glacier-pool-150": "#5d2ba1",
    "glacier-pool-200": "#6a39bb",
    "glacier-pool-250": "#7546d6",
    "glacier-pool-300": "#8055f1",
    "glacier-pool-350": "#7359f6",
    "glacier-pool-400": "#645efa",
    "glacier-pool-450": "#5362fc",
    "glacier-pool-500": "#3c67fd",
    "glacier-pool-550": "#146cfd",
    "glacier-pool-600": "#0089ff",
    "glacier-pool-650": "#0ca2ff",
    "glacier-pool-700": "#3bb9ff",
    "glacier-pool-750": "#64cdff",
    "glacier-pool-800": "#8ce0ff",
    "glacier-pool-850": "#9ae3ff",
    "glacier-pool-900": "#a7e5ff",
    "glacier-pool-950": "#b3e8fe",
    "glacier-pool-1000": "#bfeafe",
    "glacier-pool-1050": "#cbedfd"
  },
  "deep-current": {
    "deep-current-50": "#0b3f47",
    "deep-current-100": "#124b54",
    "deep-current-150": "#195862",
    "deep-current-200": "#206571",
    "deep-current-250": "#27727f",
    "deep-current-300": "#2e808e",
    "deep-current-350": "#0082a2",
    "deep-current-400": "#0082b8",
    "deep-current-450": "#007ed0",
    "deep-current-500": "#0077e7",
    "deep-current-550": "#146cfd",
    "deep-current-600": "#0089ff",
    "deep-current-650": "#0ca2ff",
    "deep-current-700": "#3bb9ff",
    "deep-current-750": "#64cdff",
    "deep-current-800": "#8ce0ff",
    "deep-current-850": "#9ae3ff",
    "deep-current-900": "#a7e5ff",
    "deep-current-950": "#b3e8fe",
    "deep-current-1000": "#bfeafe",
    "deep-current-1050": "#cbedfd"
  },
  "blue-red": {
    "blue-red-50": "#002664",
    "blue-red-100": "#013380",
    "blue-red-150": "#03419e",
    "blue-red-200": "#074fbd",
    "blue-red-250": "#0d5ddc",
    "blue-red-300": "#146cfd",
    "blue-red-350": "#4c8eff",
    "blue-red-400": "#79acff",
    "blue-red-450": "#a5c8ff",
    "blue-red-500": "#d2e4ff",
    "blue-red-550": "#fed7d6",
    "blue-red-600": "#f9afae",
    "blue-red-650": "#f18687",
    "blue-red-700": "#e55961",
    "blue-red-750": "#d7153a",
    "blue-red-800": "#bf0f34",
    "blue-red-850": "#a70a2d",
    "blue-red-900": "#8f0527",
    "blue-red-950": "#790220",
    "blue-red-1000": "#630019"
  },
  "blue-orange": {
    "blue-orange-50": "#002664",
    "blue-orange-100": "#013380",
    "blue-orange-150": "#03419e",
    "blue-orange-200": "#074fbd",
    "blue-orange-250": "#0d5ddc",
    "blue-orange-300": "#146cfd",
    "blue-orange-350": "#4c8eff",
    "blue-orange-400": "#79acff",
    "blue-orange-450": "#a5c8ff",
    "blue-orange-500": "#d2e4ff",
    "blue-orange-550": "#ffe2d6",
    "blue-orange-600": "#ffc4ad",
    "blue-orange-650": "#fea683",
    "blue-orange-700": "#fa8657",
    "blue-orange-750": "#f3631b",
    "blue-orange-800": "#e05516",
    "blue-orange-850": "#cc4611",
    "blue-orange-900": "#b9380b",
    "blue-orange-950": "#a72a05",
    "blue-orange-1000": "#941b00"
  },
  "purple-yellow": {
    "purple-yellow-50": "#441170",
    "purple-yellow-100": "#511e88",
    "purple-yellow-150": "#5d2ba1",
    "purple-yellow-200": "#6a39bb",
    "purple-yellow-250": "#7546d6",
    "purple-yellow-300": "#8055f1",
    "purple-yellow-350": "#967bf7",
    "purple-yellow-400": "#ae9efb",
    "purple-yellow-450": "#c7bffe",
    "purple-yellow-500": "#e3dfff",
    "purple-yellow-550": "#fff0da",
    "purple-yellow-600": "#ffe0b4",
    "purple-yellow-650": "#fed08b",
    "purple-yellow-700": "#fcc05d",
    "purple-yellow-750": "#faaf05",
    "purple-yellow-800": "#db9903",
    "purple-yellow-850": "#bd8402",
    "purple-yellow-900": "#a06f01",
    "purple-yellow-950": "#845b00",
    "purple-yellow-1000": "#694800"
  },
  "fuchsia-teal": {
    "fuchsia-teal-50": "#65004d",
    "fuchsia-teal-100": "#7b025f",
    "fuchsia-teal-150": "#920472",
    "fuchsia-teal-200": "#a90885",
    "fuchsia-teal-250": "#c10d99",
    "fuchsia-teal-300": "#d912ae",
    "fuchsia-teal-350": "#e65bbf",
    "fuchsia-teal-400": "#f088cf",
    "fuchsia-teal-450": "#f8b1df",
    "fuchsia-teal-500": "#fdd8ef",
    "fuchsia-teal-550": "#d6e5e8",
    "fuchsia-teal-600": "#aecbd1",
    "fuchsia-teal-650": "#86b2ba",
    "fuchsia-teal-700": "#5d99a4",
    "fuchsia-teal-750": "#2e808e",
    "fuchsia-teal-800": "#27727f",
    "fuchsia-teal-850": "#206571",
    "fuchsia-teal-900": "#195862",
    "fuchsia-teal-950": "#124b54",
    "fuchsia-teal-1000": "#0b3f47"
  }
}
